// Handles drag and drop functionality for the images field
export default class DragDropHandler {
  constructor(controller) {
    this.controller = controller
  }

  setupDropZoneClickHandler() {
    if (this.controller.hasDropZoneTarget) {
      this.controller.dropZoneTarget.addEventListener('click', (e) => {
        e.preventDefault()
        this.controller.fileInputTarget.click()
      })
    }
  }

  handleDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'copy'
  }

  handleDragEnter(event) {
    event.preventDefault()
    if (this.controller.hasDropZoneTarget) {
      this.controller.dropZoneTarget.classList.add('drag-over')
    }
  }

  handleDragLeave(event) {
    event.preventDefault()
    if (this.controller.hasDropZoneTarget && !this.controller.dropZoneTarget.contains(event.relatedTarget)) {
      this.controller.dropZoneTarget.classList.remove('drag-over')
    }
  }

  handleDrop(event) {
    event.preventDefault()

    if (this.controller.hasDropZoneTarget) {
      this.controller.dropZoneTarget.classList.remove('drag-over')
    }

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.handleFilesDrop(files)
    }
  }

  handleFilesDrop(files) {
    const imageFiles = Array.from(files).filter(file =>
      file.type.startsWith('image/') &&
      ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp'].includes(file.type)
    )

    if (imageFiles.length === 0) {
      console.warn('No valid image files were dropped')
      return
    }

    this.controller.fileManager.handleDroppedFiles(imageFiles)
  }
}